import { AdditionalSelectors } from '@makemydeal/dr-activities-dealership-picker';
import * as dealValidationSelectors from '@makemydeal/dr-dash-store/selectors/dealValidationSelectors';
import { getBffApiUrl } from '@makemydeal/dr-dash-ui-utils';

export const additionalSelectors: AdditionalSelectors = {
    getDealershipURL: (state: any) => {
        return getBffApiUrl('dealerships');
    },
    getCommonOrgId: dealValidationSelectors.getInCompleteDealCoOrgId
};
